import { Link } from "react-router-dom";
import brendanPhoto from "@/assets/brendan-photo.jpg";
import stanPhoto from "@/assets/stan-photo-circular.png";
import akimPhoto from "@/assets/akim-photo.png";
import liamPhoto from "@/assets/liam-photo.png";
import tomPhoto from "@/assets/tom-photo.png";
import sebPhoto from "@/assets/seb-photo.png";
import jorgePhoto from "@/assets/jorge-photo.png";
import kogulanPhoto from "@/assets/kogulan-photo.png";
import santiPhoto from "@/assets/santi-photo.png";
import nathanPhoto from "@/assets/nathan-photo.jpg";
import josipPhoto from "@/assets/josip-photo.jpg";
import katPhoto from "@/assets/kat-photo.png";
import reidePhoto from "@/assets/reide-photo.png";
import cameronPhoto from "@/assets/cameron-photo.png";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

interface Coach {
  name: string;
  role: string;
  photo: string;
  style?: string;
}

const coaches: Coach[] = [
  { name: "Brendan", role: "FVA 20s & SSV Team Vic", photo: brendanPhoto, style: "scale-[1.42] translate-x-[1%]" },
  { name: "Stan", role: "MV u14s Head Coach", photo: stanPhoto, style: "" },
  { name: "Akim", role: "FVA GK Coach", photo: akimPhoto, style: "scale-[1.4]" },
  { name: "Liam", role: "SSV Team Vic", photo: liamPhoto, style: "scale-[1.15] translate-y-[-5%]" },
  { name: "Tom", role: "MV Pathways Coach", photo: tomPhoto, style: "scale-[1.1]" },
  { name: "Seb", role: "FV SAP Manager", photo: sebPhoto, style: "scale-[1.1] translate-y-[10%]" },
  { name: "Jorge", role: "MC WNPL Head Coach", photo: jorgePhoto, style: "scale-[1.05]" },
  { name: "Kogulan", role: "BH WNPL Head Coach", photo: kogulanPhoto, style: "scale-[1.3] translate-x-[-10%] translate-y-[15%]" },
  { name: "Santi", role: "MV Women Asst Coach & WNPL Head Coach", photo: santiPhoto, style: "scale-[1.2] translate-y-[10%]" },
  { name: "Nathan", role: "FVA u15 Girls Head Coach", photo: nathanPhoto, style: "scale-[1.15] translate-y-[10%]" },
  { name: "Josip", role: "Football Australia Educator", photo: josipPhoto, style: "scale-[1.15] translate-y-[-5%]" },
  { name: "Kat", role: "WU A-League Womens Head Coach", photo: katPhoto, style: "scale-[1.3] translate-x-[5%]" },
  { name: "Reide", role: "MV u20 Women Head Coach", photo: reidePhoto, style: "scale-[1.15]" },
  { name: "Cameron", role: "Ex Western Academy Boys Head Coach", photo: cameronPhoto, style: "scale-[1.1] translate-y-[-5%]" },
];

export const CoachCarousel = () => {
  return (
    <div className="flex flex-col items-center gap-4">
      <span className="text-sm text-muted-foreground">Trusted by coaches across Australia</span>
      
      <Carousel
        opts={{
          align: "center",
          loop: true,
        }}
        className="w-full max-w-md"
      >
        <CarouselContent className="-ml-2">
          {coaches.map((coach) => (
            <CarouselItem key={coach.name} className="pl-2 basis-1/5">
              <Link to="/au-coaches" className="flex flex-col items-center gap-2 group cursor-pointer">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full overflow-hidden border-2 border-primary/30 bg-muted group-hover:border-primary transition-colors">
                  <img
                    src={coach.photo}
                    alt={coach.name}
                    className={`w-full h-full object-cover ${coach.style || ""}`}
                  />
                </div>
                <span className="text-[10px] sm:text-xs font-medium text-primary text-center leading-tight max-w-[60px] sm:max-w-[80px] group-hover:text-primary/80 transition-colors">{coach.role}</span>
              </Link>
            </CarouselItem>
          ))}
        </CarouselContent>
        {coaches.length > 5 && (
          <>
            <CarouselPrevious className="hidden sm:flex -left-12" />
            <CarouselNext className="hidden sm:flex -right-12" />
          </>
        )}
      </Carousel>
    </div>
  );
};
